import "./styles/normalize.css";
import "./styles/animation.css";
import "react-tooltip/dist/react-tooltip.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { MainContextProvider } from "./ContextState";
import LibraryV2 from "./libraryV2/Library";
import Slider from "./slider/Slider";


if (process.env.NODE_ENV === "production") {

}

function App() {
    return (
        <MainContextProvider>
            <div>
                <Router>
                    <Routes>
                        <Route path="/slider" element={ <Slider/> }/>
                        <Route path="/" element={ <LibraryV2/> }/>
                    </Routes>
                </Router>
            </div>
        </MainContextProvider>
    );
}

export default App;
